import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {sendResetPasswordEmail} from 'src/openapi/admin/apis/UsersEmailsApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    userId: number,
    onSuccess: () => void,
    onFail: (error: string) => void,
};

export const usePasswordResetEmail = ({userId, onSuccess, onFail}: Props) => {
    const apiDispatch = useAppDispatch();

    const eventAction = useCallback(() => apiDispatch(
        sendResetPasswordEmail({userId}),
    ), [userId, apiDispatch]);

    return useCommonEventHook({eventAction, onSuccess, onFail});
};
